import React from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import Box from 'common/Box';
import Link from 'common/Link';
import InsuranceLink from 'insurance/Link';
import * as routes from 'app/routes';
import { getAttSubscription } from 'reducers'
import add_green_circle from 'common/img/add_green_circle.svg';
import styles from './Subscription.module.css';

export const SubscriptionScreen = ({ subId, sub }) => {
  return (
    <div className={cn('Subscription', styles.wrapper)}>
      <SubscriptionSwitcher
        attSubId={subId}
        attRoute={routes.attSubscription}
        sprintRoute={routes.sprintSubscription}
        quickRoute={routes.quickSubscription}
      />
      <div className={styles.linkList}>
        {sub && !(sub.att_status === 'active' && !sub.synced_with_att)  &&
          (
            <Link className={styles.subscriptionLink} to={routes.attAddData(subId)}>
              <Box>
                <img src={add_green_circle} />
                Add Data
              </Box>
            </Link>
          )}
        <InsuranceLink className={styles.subscriptionLink} attSubId={subId} />
      </div>
    </div>
  )
}

const mapStateToProps = (state, { subId }) => ({
  sub: getAttSubscription(state, subId),
})

export default connect(mapStateToProps, null)(SubscriptionScreen);
